
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var _ = require('lodash');

var shallowEqual = function shallowEqual(a, b) {
    if (a === b) {
        return true;
    }

    if (!_.isObject(a) || a === null || !_.isObject(b) || b === null) {
        return false;
    }

    var keysA = Object.keys(a);
    var keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for (var i = 0; i < keysA.length; i++) {
        if (!bHasOwnProperty(keysA[i]) || a[keysA[i]] !== b[keysA[i]]) {
            return false;
        }
    }
    return true;
};

var withPureRender = function withPureRender(Component) {
    var PureRender = function (_React$Component) {
        _inherits(PureRender, _React$Component);

        function PureRender() {
            _classCallCheck(this, PureRender);

            return _possibleConstructorReturn(this, (PureRender.__proto__ || Object.getPrototypeOf(PureRender)).apply(this, arguments));
        }

        _createClass(PureRender, [{
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                return !shallowEqual(this.props, nextProps);
            }
        }, {
            key: 'render',
            value: function render() {
                return React.createElement(Component, this.props);
            }
        }]);

        return PureRender;
    }(React.Component);

    return PureRender;
};

module.exports = withPureRender;


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/hoc/withPureRender.js